import { useEffect, useState } from "react";
import  {getRendezVous}  from "../../api/rendezVousService.api";
import "./Dashboard.css"
import Accordion from "../../components/Accordion";
import DashboardTechnicien from "./DashboardTechnicien";
import DashboardParMois from "./DashboardParMois";
import DerniersRendezVous from "./DerniersRendezVous";

const Dashboard = () => {
  const [rendezVous, setRendezVous] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await getRendezVous();
      setRendezVous(res.data);
    } catch (err) {
      console.error("Erreur chargement dashboard", err);
    } finally {
      setLoading(false);
    }
  };

  /* =======================
     CALCULS STATISTIQUES
  ======================== */

  const totalRdv = rendezVous.length;

  const totalTermine = rendezVous.filter(
    r => r.etat_travaux === "TERMINE"
  ).length;

  const totalEnCours = rendezVous.filter(
    r => r.etat_travaux === "EN_COURS"
  ).length;

  const totalEnAttente = rendezVous.filter(
    r => r.etat_travaux === "EN_ATTENTE"
  ).length;

  const totalHeures = rendezVous.reduce((sum, r) => {
    return r.etat_travaux === "TERMINE"
      ? sum + Number(r.duree_heures || 0)
      : sum;
  }, 0);

  /* =======================
     AFFICHAGE
  ======================== */

  if (loading) {
    return <p>Chargement du tableau de bord...</p>;
  }

  return (
    <div className="dashboard-container">
      <h2>📊 Tableau de bord</h2>
  
      <div className="dashboard-grid">
        <StatCard title="Total RDV" value={totalRdv} color="#555" />
        <StatCard title="Terminés" value={totalTermine} color="#2e7d32" />
        <StatCard title="En cours" value={totalEnCours} color="#1976d2" />
        <StatCard title="En attente" value={totalEnAttente} color="#9e9e9e" />
        <StatCard
          title="Heures travaillées"
          value={totalHeures.toFixed(2) + " h"}
          color="#ff9800"
        />
      </div>
           <Accordion
        title="Derniers RDV"
        icon="📈"
      >
      <DerniersRendezVous/>
      </Accordion>
          <Accordion
            title="Statistiques par technicien"
            icon="👨‍🔧"            
          >
            <DashboardTechnicien />
          </Accordion>
         <Accordion
        title="Statistiques par mois"
        icon="📅"
      >
        <DashboardParMois />
      </Accordion>
     
    </div>
  );
};

/* =======================
   COMPOSANT CARTE
======================== */

const StatCard = ({ title, value, color }) => {
  return (
    <div className="stat-card" style={{ borderLeftColor: color }}>
      <p className="stat-title">{title}</p>
      <p className="stat-value">{value}</p>
    </div>
  );
};

export default Dashboard;
